import { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { RcsRoutes } from 'pages/settings/pages/rcs/route/type'
import { RcsPath } from 'pages/settings/pages/rcs/route/rcsPath'
import { RcsWizardProvider } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'

export const RcsWizardProviderLayout = () => {
  const { pathname } = useLocation()
  const initialPathnameRef = useRef(pathname)

  useEffect(() => {
    if (initialPathnameRef.current.includes(`/${RcsRoutes.create}`)) {
      uiStore.changeRoute({ path: RcsPath.root, method: 'replace' })
    }
  }, [])

  return (
    <RcsWizardProvider>
      <Outlet />
    </RcsWizardProvider>
  )
}
